import {services} from "../Data/ServicesData"

const Services = () => {
    return (
       <section id="pageServices" className="py-20"> 
<div className="container  m-auto w-4/5">
        <div className="row flex">
         <ul className="row grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                  {services.map((item,id)=>(
                    <li key={id} className={`GridColoum ColumCount-${id}` } >
                        <h4 className="font-bold  my-2">{item.title}</h4>
                        <p className="text-description">{item.description}</p>
                    </li>
                  ))}
             </ul>
        </div>
      </div>
       </section>
    )
}

export default Services;